import { Injectable } from '@angular/core';
import { TransformEingangCtBatchDto } from '../../models/interfaces';
import { Observable } from 'rxjs';
import { ApiService } from '@ps-gui/shared-core';

@Injectable({
  providedIn: 'root',
})
export class CtBatchTransformationApiService extends ApiService {
  protected override get baseUrl(): string {
    return this.backendUrls.ctBackendUrl;
  }

  protected override get baseUrlSuffix(): string {
    return '/api';
  }

  transformEingangCtBatch(
    transformEingangCtBatchDto: TransformEingangCtBatchDto,
  ): Observable<string> {
    return super.post('transform/eingang', transformEingangCtBatchDto);
  }
}
